export const UserLoginMessage = {
  LogginFailure: "Login Failed. Incorrect Email and Password.",
  LoginLocked: "You have entered the wrong password 5 times. Your account has been temporarily locked for 15 minutes. Please try again after 15 minutes.",
  LogginSuccess: "User logged in",
  LoginEmailBlank: "Enter Email Address",
  LoginPasswordBlank: "Enter Password",
  LoginInvalidEmail: "Enter valid Email",
  InactiveAbstractor: `Your account is inactive. Please contact the administrator at <u><a href="mailto:MMA@analysisgroup.com">MMA@analysisgroup.com</a></u> for further assistance.`,
  reCAPTCHAFail: "reCAPTCHA validation failed. Please try again."
};
export const Abstractor_Msgs = {
  FIRSTNAME: "Enter first name",
  LASTNAME: "Enter last name",
  EMAIL_REQUIRED: "Enter email address",
  EMAIL_VALID: "Please enter a valid email",
  CENTER: "Please select center",
  REQUIRED: "This field is required",
  PASSWORD_VALID:
    "Your password must contain one lowercase letter, one uppercase letter, one number, and one symbol",
  EMAIL_EXISTS: "Email address already exists",
  CENTER_LOAD_ERROR: "Error occurred while loading centers",
  ADD_SUCCESS: "Abstractor added successfully",
  EDIT_SUCCESS: "Abstractor updated successfully",
  DELETE_SUCCESS: "Abstractor deleted successfully",
  DELETE_FAIL: "Error occurred when deleting abstractor",
  EMAIL_SENDOUT_SUCCESS: "Email sent successfully", //"An email has been sent to the email address regarding the further process",
  EMAIL_SENDOUT_ERROR: "Email address does not exists",
  STATUS_CHANGE_CONFIRM: "Are you sure you want to change the status of this abstractor?",
  STATUS_CHANGE_SUCCESS: "Status updated successfully",
  STATUS_CHANGE_FAIL: "Error occurred while updating status"
};
export const Center_Msgs = {
  NAME: "Enter center name",
  ADD_SUCCESS: "Center added successfully",
  EDIT_SUCCESS: "Center updated successfully",
  DELETE_SUCCESS: "Center deleted successfully",
  DELETE_FAIL: "Error occurred when deleting center",
  NAME_EXISTS: "The center name already exists",
  CENTER_TYPE: "Select a center type",
};
export const ResetPasswordMessages = {
  PASSWORD_BLANK: "Enter Password",
  CONFIRM_PASSWORD_BLANK: "Re-Enter Password",
  PASSWORD_MISMATCH: "Passwords did not match!",
  PASSWORD_INVALID:
    "Your password should include at least one lowercase letter, one uppercase letter, one number and one symbol with a minimum length of eight characters and max sixty four characters.",
  LINK_EXPIRED: "Link has expired",
  EMAIL_NOTEXISTS: "Email address does not exists",
  PASSWORD_EXIST: "You have already used this password, please enter other password."
  //100:"Some error!!! "
};
export const CommonError_Msgs = {
  LOAD_ERR: "Error occurred while loading.",
  SAVE_ERR: "Error occurred while saving.",
  PART_2_ERR: "Save all data from Part 1 section to proceed with submission of Part 2.",
  REQUIRED: "This field is required.",
  DATE_BEFORE_1920: "Date entered is before 1920.",
  Hard_Empty:
    "Please ensure that all mandatory fields are filled out before proceeding.",
  UnknownSelect:
    "You have selected “Unknown” for this question. Please confirm that this is your choice before moving to the next question.",
  DateNotValid: "Invalid Date. Please enter a valid date.",
  //Soft
  NotInRange: "You have indicated the value as [value] [value units]. Please confirm or revise your response.",
  //the user has completed the entire section, but there is an error based on their response
  IncorrectResponse: "Please confirm or revise your responses.",

  Msg1: "Please provide a response.",
  Msg2: "You’ve entered a value outside the expected range. Please verify your answer.",
  InvalidDate: "Invalid Date. Please enter a valid date and ensure that the date is not in the future.",
  DateChangeAlert: "The dates modified could impact the validation in the subsequent pages. Please validate the pages highlighted in red.",
};
export const MessageRequired_Msg = {
  Required: "This field is required.",
};
export const ForgotPassword = {
  EmailNotExistent:
    "This Email Address has not been set up - Please contact your Administrator to set this up.",
  EmailSuccess: "An Email has been sent to you regarding the further process.",
  ErrorOccurred: "Error occurred.",
};
export const CommonMsgs = {
  DeleteConfirmMsg: "Are you sure you want to delete this data?",
  SessionTimeout: "Your session has expired, you will be logged out now.",
  SubmitSuccess: "Patient Submitted Successfully",
  Unknown:
    "You have selected “Unknown” for this question. Please confirm that this is your choice before moving to the next question.",
};
export const PatientDashboard_Msgs = {
  ExportSuccess: "Data exported successfully",
  UnlockConfirmMsg:
    "Would you like to unlock and allow the abstractors to edit this patient?",
  UnlockSuccessMsg: "Patient Unlocked successfully",
  SyncSuccessMsg: "Patient data updated successfully",
  UnlockEligibilityConfirmMsg:
    "Would you like to unlock and allow the abstractors to edit the Eligibility Criteria section of this patient?",
  ExportAllAlertMsg: "To export all patient data, please ensure at least one patient is added."
};

//ST: New Messages
export const EligibilityCriteria_Msgs = {
  Eligible: `<span>
              This patient meets the study’s eligibility criteria.
              Please click on “»” to proceed with completing the chart abstraction for this patient.
              <u>Once advancing to the next form, the patient’s eligibility screener cannot be unlocked.</u>
            </span>`,
  // Ineligible: "This patient does not meet the eligibility criteria for this study. Once validating this form, the patient will be considered ineligible for the study and their eligibility screener will be locked."
  Ineligible: "Please confirm your answer is correct. Based on the current response, this patient does not meet the eligibility criteria for this study. Once validating this form, the patient will be considered ineligible for the study and their eligibility screener will be locked."
}

export const TreatmentHistory_Msgs = {
  date: "Please enter date",
  radio: "Please select radio",
  checkbox: "Please select atleast 1 checkbox",
  text: "Please enter text"
}

export const LabAssessment_Msgs = {
  date: "Please enter date",
  radio: "Please select radio",
  text: "Please enter text"
}

export const OutcomeAssessment_Msgs = {
  date: "Please enter date",
  radio: "Please select radio",
  text: "Please enter text"
}

export const AdverseEvents_Msgs = {
  date: "Please enter date",
  radio: "Please select radio",
  text: "Please enter text"
}


export const Demographics_Msgs = {
  gender: "Please choose one of the provided options",
  race: "Please choose at least one of the provided options or “Other” or “Unknown”",
  ethnicity: "Please choose one of the provided options",
}
export const RelevantBloodTests = `
  <div>
    <table style="border-collapse: collapse; width: 50%; text-align: left; margin: 0 auto;>
      <thead style="background-color: #D0CECE;">
        <tr style="background-color: #D0CECE;">
          <th style="border: 1px solid #000; padding: 8px; font-weight: bold;">Relevant blood tests</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">Absolute lymphocyte count (ALC)</td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">Calcium</td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">Serum creatinine</td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">Serum lactate dehydrogenase (LDH)</td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">Phosphorus</td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">Potassium</td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">Uric acid</td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">Creatinine clearance level (CrCl)</td>
        </tr>
      </tbody>
    </table>
    <br/>
  </div>
`;
export const ClinicalCharacteristics_Msgs = {
  weightRequired: "Please select patient's weight.",
  q18WeightRange: "You have indicated the value as [value] [value units]. Please confirm or revise your response.",
  q18WeightRangeEmpty: "Please enter patient's weight. ",
};
export const TLS_Table = `
  <div>
            <p class="modal-popup-title">
          <b>Howard Definitions of Laboratory and Clinical Tumor Lysis Syndrome (TLS)*</b>
        </p>
        <table class="modal-popup-table-large" style="width:100%">
          <thead class="modal-popup-table-header">
            <tr>
              <th class="modal-popup-table-header-cell">Metabolic Abnormality</th>
              <th class="modal-popup-table-header-cell">Criteria for Classification of Laboratory TLS</th>
              <th class="modal-popup-table-header-cell">Criteria for Classification of Clinical TLS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="modal-popup-table-cell">Hyperuricemia</td>
              <td class="modal-popup-table-cell">Uric acid &gt;8.0 mg/dL (475.8 μmol/L) in adults or above the upper limit of the normal range for age in children</td>
              <td class="modal-popup-table-cell"></td>
            </tr>
            <tr>
              <td class="modal-popup-table-cell">Hyperphosphatemia</td>
              <td class="modal-popup-table-cell">Phosphorus &gt;4.5 mg/dL (1.5 mmol/L) in adults or &gt;6.5 mg/dL (2.1 mmol/L) in children</td>
              <td class="modal-popup-table-cell"></td>
            </tr>
            <tr>
              <td class="modal-popup-table-cell">Hyperkalemia</td>
              <td class="modal-popup-table-cell">Potassium &gt;6.0 mmol/L</td>
              <td class="modal-popup-table-cell">Cardiac dysrhythmia or sudden death probably or definitely caused by hyperkalemia</td>
            </tr>
            <tr>
              <td class="modal-popup-table-cell">Hypocalcemia</td>
              <td class="modal-popup-table-cell">Corrected calcium &lt;7.0 mg/dL (1.75 mmol/L) or ionized calcium &lt;1.12 (0.3 mmol/L)†</td>
              <td class="modal-popup-table-cell">Cardiac dysrhythmia, sudden death, seizure, neuromuscular irritability (tetany, paresthesias, muscle twitching, carpopedal spasm, Trousseau’s sign, Chvostek’s sign, laryngospasm, or bronchospasm), hypotension, or heart failure probably or definitely caused by hypocalcemia</td>
            </tr>
            <tr>
              <td class="modal-popup-table-cell">Acute kidney injury‡</td>
              <td class="modal-popup-table-cell">Not applicable</td>
              <td class="modal-popup-table-cell">Increase in the serum creatinine level of 0.3 mg/dL (26.5 μmol/L) (or a single value &gt;1.5 times the upper limit of the age-appropriate normal range if no baseline creatinine measurement is available) or the presence of oliguria, defined as an average urine output of &lt;0.5 mL/kg/hr for 6 hours</td>
            </tr>
          </tbody>
        </table>
        <p class="modal-para">
          *In laboratory TLS, two or more metabolic abnormalities must be present during the same 24-hour period within 3 days before the start of therapy or up to 7 days afterward. Clinical TLS requires the presence of laboratory TLS plus an increased creatinine level, seizures, cardiac dysrhythmia, or death.
        </p>
        <p class="modal-para">
          †The corrected calcium level in milligrams per deciliter = measured calcium level in milligrams per deciliter + 0.8 × (4 − albumin in grams per deciliter).
        </p>
        <p class="modal-para">
          ‡Acute kidney injury is defined as an increase in the creatinine level of at least 0.3 mg per deciliter (26.5 μmol per liter) or a period of oliguria lasting 6 hours or more. By definition, if acute kidney injury is present, the patient has clinical TLS.
        </p>
  </div>
`;
export const HealthCareVisit_Msgs = {
  healthCoverage: "Please select patient's healthcare coverage.",
  healthCoverageOther: "Please specify value for other healthcare coverage.",
  insurance: "Please select patient's insurance.",
  hruInOutOBVeneto: "Please specify healthcare visits between initiation of obinutuzumab and initiation of venetoclax ramp-up.",
  hruInOutOBVenetoValue: "Please enter healthcare visits.",
  hruInOutOBVenetoInvalidRange: "You have indicated the value as [value] [value units]. Please confirm or revise your response.",
  hruInOutInitVeneto: "Please specify healthcare visits between initiation of obinutuzumab and initiation of venetoclax ramp-up.",
  hruInOutInitVenetoValue: "Please enter healthcare visits.",
  hruInitVenetoInvalidRange: "You have indicated the value as [value] [value units]. Please confirm or revise your response.",

  //common Loop Messages
  categoryEmpty: "Please select patient's healthcare coverage.",
  reasonsEmpty: "Please specify a reason for visit.",
  hruVisitDateEmpty: "Please select date of healthcare visit.",
  hruVisitDateValueEmpty: "Please specify the visit date.",
  hruTreatmmentRestartDaysEmpty: "Please specify days.",
  hruTreatmmentRestartEmpty: "Please specify how many days after the visit the treatment was restarted for visit.",
  venetoInitRamUpInvalidDate: "The patient’s healthcare visits (inpatient or outpatient) date(s) must be on or after the initiation of obinutuzumab on [insert Index Date] and before the initiation of venetoclax ramp-up on [insert Venetoclax Start Date]. Please confirm or revise your response.",
  venetoRestartedInvalidDays: "You have indicated the patient restarted treatment after the initiation of venetoclax therapy on [insert Venetoclax Start Date]. Please confirm or revise your response.",
  venetoInitRamUpCompleteInvalidDate: "The patient’s healthcare visits (inpatient or outpatient) date(s) must be on or after the initiation of venetoclax therapy on [insert Venetoclax Start Date] and on or before the end of venetoclax ramp-up on [insert Venetoclax End Date]. Please confirm or revise your response.",
  venetoRestartedCompleteInvalidDays: "You have indicated the patient restarted treatment after the venetoclax ramp-up ended on [insert Venetoclax End Date]. Please confirm or revise your response.",
  invalidDate: "Invalid Date. Please enter a valid date.",
};
export const TreatmentInterruption_Msgs = {
  total_No_interruptionsEmpty: "Please Select Yes , No or Unknown",
  total_No_interruptions_txtEmpty: " Please enter interruptions/dose holds or select Unknown",
  total_No_interruptions_txt_valueEmpty: "Please enter interruptions/dose holds value",
  interruption_DateEmpty: "Please enter date of treatment interruption/dose hold or select Unknown",
  interruption_Date_ValueEmpty: "Please enter date of treatment interruption/dose hold",
  veneto_Restarted_DateEmpty: "Please enter date in which the venetoclax ramp-up was restarted or select Not applicable or Unknown",
  veneto_Restarted_Date_ValueEmpty: "Please enter date in which the venetoclax ramp-up was restarted",
  interruptoinsNoOrUnkErrorMsg: "You previously indicated that a treatment interruption/dose hold was used as an intervention following a prior lab result. Please confirm your response.",
  rangeInvalidErrorMsgStart: "You have indicated the value as ",
  rangeInvalidErrorMsgEnd: " interruptions/dose holds. Please confirm or revise your response.",
  invalidDate: "Invalid Date. Please enter a valid date.",
}
export const VenRampUp_Msgs = {
  doseEmpty: "Please choose one of the provided options",
  weeksEmpty: "Please enter the weeks",
  agentEmpty: "Please select the uric acid reduction agents",
  agentTxtEmpty: "Please enter the text",
  //Rpt
  rcvdDateEmpty: "Please enter the date when the first venetoclax ramp-up dose was received.",

  HrsEmpty: "Please enter the time(hours).",
  MinsEmpty: "Please enter the time(mins).",
  HrsMinsEmpty: "Please enter the time(hours) and time(mins).",

  wk1DoseDate: "You indicated the patient initiated venetoclax on {venStartDt}, but started initiated their ramp-up of venetoclax on {doseDt}. Please confirm or revise your response.",
  doseDtLessThanPrior: "The date of venetoclax ramp-up in week {currWk} must be after the date of venetoclax ramp-up in week {prevWk}. Please confirm or update your response.",
  Radio: "Please choose one of the provided options",
  medTxtEmpty: "Please enter the text",
  strongCyp3a: "You have indicated that the patient received a strong CYP3A inhibitors which would deem the patient ineligible for the study. Please confirm or revise your response.",
  doseReceivedTxtEmpty: "Please enter the dose",
  adminTxtEmpty: "Please enter the text",
  Select: "Please choose at least one of the options provided.",
}
export const TLSMonitoring_Msgs = {
  Select: "Please choose at least one of the options provided.",
  TextEmpty: "Please enter the value",
  Total_No_interruptionsEmpty: "Please choose at least one of the provided options",
  InvalidRange: "You have indicated the value as ",
  InvalidRangeEmptyRemining: " radiographic evaluations. Please confirm or revise your response.",
  TestCompleteTxtEmptyMsg: "You have indicated the value as [value] [value units]. Please confirm or revise your response.",
  BloodTestCountEmpty: "Please specify blood test count.",
  BloodTestCompleteCountEmptyMsg: "You have indicated the value as [value] [value units]. Please confirm or revise your response.",
  testperformed_dtSoft: "This test was completed more than 2 months before initiation of VO therapy or after the initiation of venetoclax (i.e, outside of {Index date – 2 months} and {Venetoclax Start Date}). Please confirm or revise your response.",
  lymphnodesizeSoft: "You have indicated the value as {value} cm. Please confirm or revise your response.",
  lymphNodegreaterthanfiveTxtSoft: "You have indicated the value as {value} lymph nodes. Please confirm or revise your response.",
  testperformedDateEmpty: "Please enter the date when the test was performed.",
  HrsEmpty: "Please enter the time(hours).",
  MinsEmpty: "Please enter the time(mins).",
  sizeTxtEmpty: "Please enter size of largest lymph node.",
  sizeTxtymphNodegreaterthanfiveTxt: "Please enter identified number of lymph node greater than 5cm.",
  HrsMinsEmpty: "Please enter the time(hours) and time(mins).",

  Radio: "Please choose one of the provided options",
  q36T1ADateEmptyMsg: "Please enter date of blood draw",
  q36T1ADateCheckErrorMsg: "The date of the [N] blood draw must be after the date of the [N-1] blood draw. Please confirm or update your response.",
  q36T1ADateVenCheckErrorMSg: "The lab test must have been completed during the venetoclax ramp-up period. Please confirm or update your response.",

  q36T1BSubValueEmptyMsg: "Please choose one of the sub options provided",
  q36T1CTimeEmptyMsg: "Please enter other time of blood draw",
  q36T1CHrsEmptyMsg: "Please enter hours",
  q36T1CMinsEmptyMsg: "Please enter mins",
  q36T1FOtherTxtEmptyMsg: "Please enter the other text value",
  testresultSoft: "You have indicated the value as {value} mL/min. Please confirm or revise your response.",
  alc_datetestperformed_dtEmptyMsg: "Please enter the date when the test was performed.",
  crcl_datetestperformed_dtEmptyMsg: "Please enter the date when the test was performed.",
  alc_testresultTxtEmptyMsg: "Please enter test result.",
  crcl_testresultTxtEmptyMsg: "Please enter test result.",

  q36T1FChildEmptyMsg: "Please choose one of the sub options provided",
  q36T2DResultEmptyMsg: "Please enter the test result value",
  q36T2COthTxtEmptyMsg: "Please enter the other formula type value",
  q36T2DAllUnknownEmptyMsg: "You have indicated that the test results are unknown for all of the specified blood tests completed. Please review your response. Please note that as part of patient eligibility you must have complete information for each patient.",
  q36T2BAllUnkNotTestedEmptyMsg: "You have indicated that none of the specified blood tests were completed. Please review your response. Please note that as part of patient eligibility you must have complete information for each patient.",
  q36T1ColBCSoftMsg: "You previously indicated a prior lab was used for pre-dose TLS assessment as per label. Please confirm whether this was a later TLS assessment or a repeat lab within the same time frame.",
}
export const GetPatientModal_Msgs = {
  invalidPatient: "Please enter valid patient ID and select a patient."
}
export const TLS_Cairo = `
  <div>
            <p class="modal-popup-title">
          <b>Cairo-Bishop Definitions of Laboratory and Clinical Tumor Lysis Syndrome (TLS)</b>
        </p>
        <table class="modal-popup-table-large" style="width:100%">
          <thead class="modal-popup-table-header">
            <tr>
              <th class="modal-popup-table-header-cell">Elements</th>
              <th class="modal-popup-table-header-cell">Criteria for Classification of Laboratory TLS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="modal-popup-table-cell">Hyperuricemia</td>
              <td class="modal-popup-table-cell">Uric acid >8.0 mg/dL (476 μmol/L) or 25% increase from baseline </td>
            </tr>
            <tr>
              <td class="modal-popup-table-cell">Hyperphosphatemia</td>
              <td class="modal-popup-table-cell">Phosphorus >1.45 mmol/L in adults or 2.1 mmol/L in children or 25% increase from baseline</td>
            </tr>
            <tr>
              <td class="modal-popup-table-cell">Hyperkalemia</td>
              <td class="modal-popup-table-cell">Potassium >6.0 mmol/L or 25% increase from baseline</td>
            </tr>
            <tr>
              <td class="modal-popup-table-cell">Hypocalcemia</td>
              <td class="modal-popup-table-cell">Corrected calcium <7.0 mg/dL (1.75 mmol/L) or 25% increase from baseline</td>
            </tr>
          </tbody>
        </table>
  </div>
  <br />
`;


export const Last_Patient_Encounter = `
<div>
  <p style="text-align: left;">
  This can be a visit, telehealth consultation, lab test, imaging report, or any other recorded date in the patient chart. For the first patient record, this would indicate the earliest available record in the patient chart. For the last patient record, this would indicate the last available record prior to or on the date that abstraction began for this chart.
  </p>
</div>
`;


export const MDE_Popup = `
<div>
  <p style="text-align: left;">
    Patients with MMA due to mutase enzyme deficiency who have undergone LT or LKT and experienced metabolic decompensation events (MDEs, also known as metabolic crises) prior to transplant is an imperative subpopulation for understanding the relationships between reductions in methylmalonic acid levels and reductions in rates of MDEs.
  </p>
  <br/>
  <p style="text-align: left;">
    We encourage sites to use their own criteria for defining MDEs. If not having a standardized definition of MDE or common clinical criteria considered for determining a MDE, we ask that sites please define MDEs as having <u>all</u> the following criteria: 
  </p>
  <ol style="text-align: left; padding-left: 20px;">
    <li>
      <b>Exacerbation of MMA-related signs and symptoms,</b> which may include but are not limited to persistent vomiting, anorexia, failure to feed/food intolerance, lethargy/decreased activity, increased seizure activity, etc.
    </li>
    <li>
      <b>Setting of acute medical care,</b> which may include visits within inpatient, intensive care unit (ICU), emergency room (ER), or outpatient settings.
    </li>
    <li>
      <b>Indications of biochemical abnormalities, with specific focus on:</b>
      <ul style="list-style-type: circle; padding-left: 20px;">
        <li>
          <u>Metabolic acidosis</u> (decreased pH with a high anion gap), as determined by the treating physician and supported by laboratory testing, or
        </li>
        <li>
          <u>Compensated metabolic acidosis</u> (reduced bicarbonate, reduced base deficit, reduced PaCO2, or increased lactate, and a high anion gap), as determined by the treating physician and supported by laboratory testing, or 
        </li>
        <li>
          Acute hyperammonemia (increased ammonia), as determined by the treating physician and supported by ammonia laboratory testing results
        </li>
      </ul>
    </li>
  </ol>
</div>
`;

export const Transplant_Visit = `
<div class="font-bold">
  <p style="text-align: left;">
  Defined as a hospitalization related to a procedure, complication, or follow-up visit for LT/LKT, as determined by the treating physician.
  </p>
</div>
`;

export const NonTransplant_Visit = `
<div class="font-bold">
  <p style="text-align: left;">
  Defined as a non-transplant-related hospitalization for treatment of a complication or manifestation of MMA, as determined by the treating physician. Note: this does not include MDE-related hospitalizations; these are captured separately under the section <i class="indigo-text">Metabolic Decompensation Events (MDEs).</i>
  </p>
</div>
`;

export const NonMMA_Visit = `
<div class="font-bold">
  <p style="text-align: left;">
  Defined as any hospitalization that is not related to a procedure, complication, or follow-up visit for treating the patient’s MMA disorder (i.e., any hospitalization not defined as a transplant-related or non-transplant-related visit) hospitalization. For these other hospitalizations, the reason for hospitalization should be reported.
  </p>
</div>
`;

export const At_Home_Diet = `
<div class="font-bold">
  <p style="text-align: left;">
  The maintenance diet, commonly referred to as an “at-home diet”, is defined as any dietary restriction (protein intake restriction, caloric restriction, etc.), dietary supplement, or other prescribed dietary management practices followed by a patient for the chronic management of MMA. Such a diet aims to mitigate MMA-related signs and symptoms.
  </p>
</div>
`;

export const Sick_Day_Diet = `
<div class="font-bold">
  <p style="text-align: left;">
  The sick-day diet is defined as any dietary restriction (protein intake restriction, caloric restriction, etc.), dietary supplement, method of food intake (enteral feeding, tube feeding, etc.) or other prescribed dietary management practices implemented <u>in addition to or in replace of the maintenance or “at home” diet</u> to mitigate the onset of a metabolic decompensation event (MDE) or metabolic crisis.
  </p>
</div>
`;


export const hyperlinkTextS2 = `
<div class="font-bold">
  <p style="text-align: left;">This includes either:</p>
  <ol>
    <li style="text-align: left;">At least one piece of evidence (e.g., patient medical record, genetic testing, etc.) indicating MMA diagnosis within the patient’s medical record, or</li>
    <li style="text-align: left;">Genetic testing showing deficiency of the methylmalonyl-CoA mutase (<i>mut</i>) enzyme (<i>mut<sup>0</sup></i> or <i>mut<sup>–</sup></i>).</li>
  </ol>
</div>
`;


export const hyperlinkTextCombinedLKT = `
<div class="font-bold">
  <p style="text-align: left;">
  <span>
  Patients who undergo a combined LKT are expected to have one procedure to replace both the liver and the kidney(s). It is expected that both transplanted organs are received on the same day.
  </span>
  </p>
</div>
`;

export const hyperlinkTextSequentialLKT = `
<div class="font-bold">
  <p style="text-align: left;">
  <span>
  Patients who undergo a sequential LKT are expected to have one transplanted organ procedure first (oftentimes the liver) followed by the second procedure (i.e., kidney(s) transplant) several weeks or months thereafter.</span>
  </p>
</div>
`;


export const hyperlinkTextTransplantVisits = `
<div>
  <p style="text-align: left;">
  <span>
Defined as a <u>liver transplant</u> hospitalization, ER visit, or ICU/NICU visit related to a procedure, complication, or follow-up visit for LT/LKT (and not resulting in an MDE). <u>This should not include visits related to only a kidney transplant or the hospital admission and discharge related to the index date LT/LKT procedure.</u>  </p>
</div>
`;


export const hyperlinkTextLiver = `
<div class="font-bold">
  <p style="text-align: left;">
  <span>
  Note that if the patient’s liver transplant was conducted in multiple stages (i.e., one procedure replacing liver with temporary shunt, one procedure replacing shunt with donor liver), this is not considered a re-transplantation. Patients having transplantation and re-transplantation of other organs are permitted in the study, including those with kidney re-transplantation.  </p>
</div>
`;


export const mdeRelatedVisit = `
<div>
  <p style="text-align: left;">
    Defined as a hospitalization, ER visit, ICU/NICU, or outpatient visit associated with the occurrence of an MDE, as defined by an acute medical care visit, and indications of a biochemical abnormality.  </p>
</div>
`;

export const zeroToTwelve = (oneYearPreTransplantStart, oneYearPreTransplantEnd) => `
<div class="font-bold">
  <p style="text-align: left;">
    Defined from ${oneYearPreTransplantStart} to ${oneYearPreTransplantEnd}, inclusive.
  </p>
</div>
`;

export const zeroToThree = (indexDate, threeMonthsStabilizationDate) => `
<div class="font-bold">
  <p style="text-align: left;">
    Defined from ${indexDate} to ${threeMonthsStabilizationDate}, inclusive.
  </p>
</div>
`;

export const fourToFifteen = (postStabilizationStartDate, twelveMonthsPostStabilizationDate) => `
<div class="font-bold">
  <p style="text-align: left;">
   Defined from ${postStabilizationStartDate} to ${twelveMonthsPostStabilizationDate}, inclusive.
  </p>
</div>
`;

export const sixteenToTwentySeven = (twelveMonthsPostStabilizationDatePlusOneDay, twentyFourPostStabilizationDate) => `
<div class="font-bold">
  <p style="text-align: left;">
    Defined from ${twelveMonthsPostStabilizationDatePlusOneDay} to ${twentyFourPostStabilizationDate}, inclusive.
  </p>
</div>
`;

export const Transplant_MMA_Related_Visit = `
<div class="font-bold">
  <p style="text-align: left;">
  Defined as a non-transplant-related hospitalization, ER visit, or ICU/NICU visit for treatment of a complication or manifestation of MMA (and not resulting in an MDE). <u><i>Any visit reported here should not have been reported in previous questions</u></i>.
  </p>
</div>
`;


export const Transplant_MDE_Related_Visit = `
<div class="font-bold">
  <p style="text-align: left;">
  Defined as a hospitalization, ER visit, ICU/NICU, or outpatient visit associated with the occurrence of an MDE, as defined by the exacerbation of MMA-related signs and symptoms, an acute medical care visit, and indications of a biochemical abnormality.
  </p>
</div>
`;



export const hyperlinkTextMDEs = `
<div>
  <p style="text-align: left;">We encourage sites to use their own criteria for defining MDEs. If not having a standardized definition of MDE or common clinical criteria considered for determining a MDE, we ask that sites please abstract MDEs using the following guidance, where MDEs are identified as having both the following:</p>
  <ol>
    <li style="text-align: left;"><b>Setting of acute medical care,</b> which may include visits within inpatient/hospital, intensive care unit (ICU) or neonatal ICU (NICU), emergency room (ER), or outpatient settings
    <ul>
      <li class="important-item-circle">
      Please use the "Other" settings option for MDEs beginning with encounters such as dietitian consultations, telehealth visits, etc. 
      </li>
 
      <li class="important-item-circle">
        If an MDE is determined to have occurred in multiple consecutive care settings (e.g., patient transferred from ER to hospital), the duration of the MDE will be defined from the start date of the earliest care setting encounter to the discharge date of the latest care setting encounter.                       
    </li>
    <br />
    </ul>
    <li style="text-align: left;"><b>Indications of biochemical abnormalities anytime within 3 days before, during, or 3 days after (±3 days) the acute medical care encounter, as determined by information contained within the patient’s medical record or supported by laboratory testing, with specific focus on:</b>
    <ul>
                              <li class="important-item-circle">
                               <u>Metabolic acidosis</u> (decreased pH with a high anion gap, including compensated metabolic acidosis [reduced bicarbonate, reduced base deficit, reduced PaCO2, or increased lactate, and a high anion gap], or 
                              </li>
                              <li class="important-item-circle">
                                <u>Acute hyperammonemia</u> (increased ammonia)
                              </li>
                            </ul>
    </li>
  </ol>
</div>
`;


export const MDE_Msgs = {
  mdeLimitReached: "You have reached the maximum limit of 25 MDE forms. You cannot add more forms.",
}